// extracted by mini-css-extract-plugin
module.exports = {"slickCurrent":"YogaSandhyaBrownGallery_slickCurrent__D00ut","slickDeactive":"YogaSandhyaBrownGallery_slickDeactive__dG9nw"};